export default ($wire, id, path) => ({
    openFeaturedListing: async function () {
        // Open window before delay to prevent popup from being blocked
        const newWindow = window.open('', '_blank');
        await $wire.setSources();
        newWindow.location = path;
    },
});
